/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {
  AfterViewInit,
  Component,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {BaseChipSelectorZoneComponent} from '../../base-chip-selector-zone.component';
import {ChipSelectorZoneDropdownModel} from './chip-selector-zone-dropdown.model';
import {ChipSelectorZoneDropdownOptionModel} from './chip-selector-zone-dropdown-option/chip-selector-zone-dropdown-option.model';
import {BaseChipSelectorZoneTooltipEnum} from '../../base-chip-selector-zone-tooltip.enum';
import {
    Observable,
    of
} from 'rxjs';
import {EntityGroupDetailDropdownOptionModel} from '../../../../settings/roles-management/users-table/models/entity-group-detail-dropdown-option.model';

@Component({
    selector: 'app-chip-selector-zone-dropdown',
    templateUrl: './chip-selector-zone-dropdown.component.html',
    styleUrls: ['./chip-selector-zone-dropdown.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChipSelectorZoneDropdownComponent
        extends BaseChipSelectorZoneComponent
        implements ChipSelectorZoneDropdownModel, AfterViewInit {
    initialValue: ChipSelectorZoneDropdownOptionModel;
    options: ChipSelectorZoneDropdownOptionModel[];
    hasUserInput = false;

    @ViewChild('tooltipTemplate', {static: true})
    tooltipTemplate: TemplateRef<unknown>;
    searchFunction = (term: string): Observable<any> => of(undefined);
    inputFormatter = (option: EntityGroupDetailDropdownOptionModel): string => '';

    get itemTitle(): string {
        return this.state?.selectOptionValue?.viewModeTransform?.() ?? this.state?.selectOptionValue?.titleTransform();
    }

    get itemTooltip(): string | TemplateRef<unknown> {
        let tooltip: string | TemplateRef<unknown>;

        if (this.hasCustomTooltip) {
            if (this.state.selectOptionValue.tooltip.constructor === String) {
                tooltip = this.state.selectOptionValue.tooltip;
            } else {
                tooltip = this.tooltipTemplate;
            }
        } else {
            tooltip = this.itemTitle;
        }

        return tooltip;
    }

    get isTooltipDynamic(): boolean {
        return this.state?.selectOptionValue?.tooltipType === BaseChipSelectorZoneTooltipEnum.DYNAMIC;
    }

    ngAfterViewInit(): void {
        this.selectOption(this.initialValue);
        this.changeDetectorRef.detectChanges();
    }

    arrowClass(isOpen: boolean): string {
        return isOpen ? 'iwp-icon-gen_arrow_up' : 'iwp-icon-gen_arrow_down';
    }

    selectOption(option: ChipSelectorZoneDropdownOptionModel): void {
        this.storeState({selectOptionValue: option});
        this.change.emit(option);
    }

    showDropdownOption(): string {
        if (this.state?.selectOptionValue != null) {
            return this.itemTitle;
        } else {
            return this.placeholder;
        }
    }

}
